import { keyframes } from "styled-components";

export class Animations {
  static POPUP = keyframes`
    0% {transform: scale(0)}
    100% {transform: scale(1)}
  `;
  static FADE_IN = keyframes`
    0% {opacity: 0}
    100% {opacity: 1}
  `;

  static SHINE = keyframes`
    0% {filter: brightness(1)}
    50% {filter: brightness(1.2)}
    100% {filter: brightness(1)}
  `;
}



// WEBPACK FOOTER //
// ./app/styling/animations.ts